import {
    convertBooleanMapToTotal,
    convertPerQuestionDiagramToTotal,
    convertPerQuestionDiagramToTotalCount,
    convertPerQuestionNestedBooleanMapToPerQuestion,
} from '../../../../utils/model-progress.helper'

export const normalizeFetchVersionsResponse = response =>
    response.map(version => ({
        id: version.id,
        isDefault: version.is_default,
        isPublished: version.is_published,
        name: version.name,
        testsetPercentage: version.testset_percentage,
        changesHistory: version.changes_history,
        ticketNumber: version.ticket_number,
        changesAuthor: version.changes_author,
    }))

export const normalizeFetchProgressResponse = response => {
    const questionPatterns = convertPerQuestionNestedBooleanMapToPerQuestion(response.patterns)

    return {
        // model
        originalModel: response,
        questions: response.questions,
        patterns: questionPatterns,
        rerunTraining: response.rerun_training,
        trainQuestions: response.train_questions,
        reviewFlagging: response.review_flagging,
        reviewTrainingMismatches: response.review_training_mismatches,
        totalQuestions: convertBooleanMapToTotal(response.questions),
        totalPatterns: convertPerQuestionDiagramToTotal(questionPatterns),
        totalRerunTraining: convertBooleanMapToTotal(response.rerun_training),
        totalTrainQuestions: convertBooleanMapToTotal(response.train_questions),
        totalReviewFlagging: convertPerQuestionDiagramToTotalCount(response.review_flagging),
        totalReviewTrainingMismatches: convertPerQuestionDiagramToTotalCount(response.review_training_mismatches),
        publishVersion: response.publish_version,
        createMba: response.create_mba,
        flagging: response.flagging,

        // mba
        importFromLms: response.import_from_lms,
        exportToLms: response.export_to_lms,
        reviewResults: response.review_results,
        totalReviewResults: convertPerQuestionDiagramToTotal(response.review_results),
    }
}
